import React from 'react';
import Header from '../common/header';
import Footer from '../common/footer';
import About1 from '../layout/about/about1';
import Termsandconditionspage from '../layout/termsandconditions/termsandconditions';


function Termsandconditions(){
    return(
        <div>
            <Header/>
            <br/>
        <Termsandconditionspage></Termsandconditionspage>
            <br/>
            <Footer/>
        </div>
    )
}
export default Termsandconditions;